module.exports = __webpack_public_path__ + "static/media/palmsbet.4aff1d38.png";